import { motion } from 'framer-motion';
import './MBZProfesional.css';

export default function MBZProfesional() {
  const tarifas = [
    {
      key: 'standard',
      title: 'Tarifa <span class="accent">Estándar</span>',
      price: '200€',
      desc: 'Pensada para deportistas que busquen un servicio presencial.',
      features: [
        { name: 'Número de sesiones a la semana', value: '2' },
        { name: 'Máximo número de personas',      value: '3' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Informes de seguimiento y contacto estrecho con el club', toggled: true },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre de instalaciones',      toggled: true },
        { name: 'Servicios de fisioterapia y rehabilitación de lesiones', value: '20% dto' }
      ]
    },
    {
      key: 'reducida',
      title: 'Tarifa <span class="accent">Reducida</span>',
      price: '150€',
      desc: 'Pensada para deportistas jóvenes o con menor disponibilidad presencial.',
      features: [
        { name: 'Número de sesiones a la semana', value: '1' },
        { name: 'Máximo número de personas',      value: '3' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Informes de seguimiento y contacto estrecho con el club', toggled: true },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre de instalaciones',      toggled: false },
        { name: 'Servicios de fisioterapia y rehabilitación de lesiones', value: '10% dto' }
      ]
    },
    {
      key: 'online',
      title: 'Tarifa <span class="accent"><br>Online</span>',
      price: '125€',
      desc: 'Para deportistas que se encuentren a distancia o busquen un plan autónomo.',
      features: [
        { name: 'Número de sesiones a la semana', value: '-' },
        { name: 'Máximo número de personas',      value: '-' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Informes de seguimiento y contacto estrecho con el club', toggled: true },
        { name: 'Planificación online (App Móvil)', toggled: true },
        { name: 'Uso libre de instalaciones',      toggled: false },
        { name: 'Servicios de fisioterapia y rehabilitación de lesiones', toggled: false }
      ]
    },
    {
      key: 'iniciacion',
      title: 'Tarifa <span class="accent">Iniciación</span>',
      price: '120€',
      desc: 'Para jóvenes que busquen complementar su práctica deportiva.',
      features: [
        { name: 'Número de sesiones a la semana', value: '2' },
        { name: 'Máximo número de personas',      value: '4' },
        { name: 'Valoraciones funcionales',       toggled: true },
        { name: 'Informes de seguimiento y contacto estrecho con el club', toggled: false },
        { name: 'Planificación online (App Móvil)', toggled: false },
        { name: 'Uso libre de instalaciones',      toggled: false },
        { name: 'Servicios de fisioterapia y rehabilitación de lesiones', toggled: false }
      ]
    }
  ];

  return (
    <div className="mbz-container">
      <motion.h1
        className="mbz-title"
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
      >
        MBZ PROFESIONAL
      </motion.h1>

      <motion.p
        className="mbz-description"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.8 }}
      >
        Para deportistas que busquen un plan personalizado para maximizar su rendimiento y prevenir lesiones.
      </motion.p>

      <motion.div
        className="mbz-precios"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      >
        {tarifas.map(plan => (
          <div key={plan.key} className={`mbz-precio-cell ${plan.key}`}>
            <h3
              className="mbz-precio-title"
              dangerouslySetInnerHTML={{ __html: plan.title }}
            />
            <div className="mbz-price-pill">{plan.price}</div>
            <p className="mbz-desc">{plan.desc}</p>
            <div className="stripe" />

            <ul className="mbz-features">
              {plan.features.map((f, i) => (
                <li key={i}>
                  <span>{f.name}</span>
                  {f.toggled !== undefined && (
                    <label className="switch">
                      <input type="checkbox" checked={f.toggled} disabled />
                      <span className="slider"></span>
                    </label>
                  )}
                  {f.value && (
                    <span className="feature-value">{f.value}</span>
                  )}
                </li>
              ))}
            </ul>
          </div>
        ))}
      </motion.div>

      <motion.div
        className="mbz-disclaimer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1.0, duration: 0.8 }}
      >
        <h2>Algunas observaciones</h2>
        <p>
          – la planificación de cada deportista es totalmente individualizada y adaptada a las necesidades personales, al margen de que se pueda compartir el espacio de entrenamiento.
        </p>
        <p>
          – los planes online se realizan a través de la aplicación móvil{' '}
          <a
            href="https://www.bridgeathletic.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            Bridge Athletic
          </a>, que permite una prescripción individualizada, guiada con vídeos y con vías de comunicación directas entre el deportista y el entrenador.
        </p>
      </motion.div>
    </div>
  );
}
